<mat-form-field [formGroup]="dateRangeField" class="wideInput" appearance="outline"
  [ngClass]="{ 'error-border': customErrorMessage }">

  <mat-label [ngClass]="{ 'error-text': customErrorMessage }">
    {{ label }}
  </mat-label>

  <mat-date-range-input [formGroup]="dateRangeField" [required]="isRequired" [rangePicker]="dp"
    [max]="maxOneYearFromNow" [min]="earliestQueriedReportDate">

    <input matStartDate #startDateInput formControlName="start" [attr.aria-label]="label" [placeholder]="!isDateAllowed ? 'From (mm/yyyy)' : 'From (dd-mmm-yyyy)'"
      (dateChange)="handleDateChange(startDateInput, 'start')">

    <input matEndDate #endDateInput formControlName="end" [placeholder]="!isDateAllowed ? 'To (mm/yyyy)' : 'To (dd-mmm-yyyy)'" [attr.aria-label]="label"
      [max]="maxOneYearFromNow" [min]="earliestQueriedReportDate" (dateChange)="handleDateChange(endDateInput, 'end')">
  </mat-date-range-input>

  <mat-datepicker-toggle matIconSuffix [for]="dp">
  </mat-datepicker-toggle>

  <mat-date-range-picker #dp [startView]="!isDateAllowed ? 'multi-year' : 'month'" (monthSelected)="setMonthAndYear($event, dp)"
    panelClass="example-month-picker">
  </mat-date-range-picker>

  @if (
  (dateRangeField.controls['start'].errors &&
  dateRangeField.controls['start'].errors['required']) ||
  (dateRangeField.controls['end'].errors &&
  dateRangeField.controls['end'].errors['required'])
) {
  <mat-error>
    {{ label }} is required.
  </mat-error>
} @else if (
  dateRangeField.controls['start'].errors ||
  dateRangeField.controls['end'].errors
) {
  <mat-error>
    Invalid date(s)
  </mat-error>
}

  @if (customErrorMessage) {
  <mat-hint [ngClass]="{ 'error-text': customErrorMessage }">
    {{ customErrorMessage }}
  </mat-hint>
  }

</mat-form-field>